import { MapsAPILoader } from '@agm/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAddressDto } from 'src/app/core/models';
import { ToastService } from 'src/app/core/services';
import { Utils } from '../../utils/utils';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'ic-google-address',
  templateUrl: './google-address.component.html',
  styleUrls: ['./google-address.component.scss'],
})
export class GoogleAddressComponent implements OnInit {
  public googleAddressForm: FormGroup;
  public formErrors: any = {};
  public mapAddress = {} as IAddressDto;
  public isValid = false;
  @ViewChild('searchLocation') public searchElementRef: ElementRef;
  @Input() googleAddress: IAddressDto;
  @Output() googleAddressEvent = new EventEmitter<IAddressDto>();
  private geoCoder: any;

  constructor(
    private readonly mapsAPILoader: MapsAPILoader,
    private readonly ngZone: NgZone,
    private readonly toastService: ToastService,
    private readonly fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.googleAddressForm = this.fb.group({
      googleAddressLoc: ['', [Validators.required]],
    });

    // This forces validation.
    Object.keys(this.googleAddressForm.controls).forEach((key) => {
      this.googleAddressForm.get(key).markAsTouched();
    });

    this.googleAddressForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.googleAddressForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });

    this.mapsAPILoader.load().then(() => {
      // this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();
      let options = {
        componentRestrictions: { country: 'us' },
        fields: ['address_components', 'geometry', 'icon', 'name'],
        strictBounds: false,
        types: ['address'],
      };

      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        options
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.mapAddress.latitude = place.geometry.location.lat();
          this.mapAddress.longitude = place.geometry.location.lng();
          this.getAddress(this.mapAddress.latitude, this.mapAddress.longitude);
        });
      });
    });

    if (this.googleAddress) {
      this.mapAddress = Utils.deepCopy(this.googleAddress);
      this.googleAddressForm.patchValue({
        googleAddressLoc: this.googleAddress.address,
      });
      this.googleAddressEvent.emit(this.mapAddress);
      this.isValid = true;
    }
  }

  get fc() {
    return this.googleAddressForm.controls;
  }

  getAddress(latitude: number, longitude: number) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results: any, status: any) => {
        if (status === 'OK') {
          if (results && results.length > 0) {
            this.mapAddress.address = this.searchElementRef.nativeElement.value;
            this.mapAddress.googleAddress = results[0].formatted_address;
            for (let i = 0; i < results.length; i++) {
              for (let j = 0; j < results[i].address_components.length; j++) {
                for (
                  let k = 0;
                  k < results[i].address_components[j].types.length;
                  k++
                ) {
                  if (
                    results[i].address_components[j].types[k] == 'postal_code'
                  ) {
                    this.mapAddress.zipCode =
                      results[i].address_components[j].short_name;
                      this.googleAddressEvent.emit(this.mapAddress);
                      this.isValid = true;
                      return;
                  }
                }
              }
            }
            this.googleAddressEvent.emit(this.mapAddress);
            this.isValid = true;
          } else {
            this.toastService.showInfo('No results found');
          }
        } else {
          this.toastService.showError('Geocoder failed due to: ' + status);
        }
      }
    );
  }

  validateLocation() {
    this.isValid = false;
    this.googleAddressEvent.emit(null);
  }

  //NOT IN USE
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.mapAddress.latitude = position.coords.latitude;
        this.mapAddress.longitude = position.coords.longitude;
        this.getAddress(this.mapAddress.latitude, this.mapAddress.longitude);
      });
    }
  }
}
